import { Appearance } from "common/generator/components/button-appearance";
import { isEmptyOrUndefinedish } from "common/Support";
import { GlideFC } from "lib/glide-fc";
import * as React from "react";
import { GlideIcon } from "sharedUI/ui/views/glide-icon/glide-icon";
import "twin.macro";
import { WireButton } from "../wire-button/wire-button";

interface Props {
    title: string;
    actionTitle?: string;
    onAction?: () => void;
    searchValue?: string;
    onSearchChange?: (newVal: string) => void;
}

export const WireListContainer: GlideFC<React.PropsWithChildren<Props>> = p => {
    const { actionTitle, title, onAction, children, onSearchChange, searchValue } = p;
    return (
        <div tw="flex flex-col">
            <div tw="flex justify-between items-center mb-2">
                <div tw="text-2xl text-text-dark font-extrabold">{title}</div>
                <div tw="flex all-child:not-last:(mr-2)">
                    {onSearchChange !== undefined && (
                        <label
                            tw="border-border-base border-radius[9px] border bg-n0 flex flex-shrink h-10 px-3
                                items-center focus-within:(ring-2 ring-accent)">
                            <GlideIcon
                                iconSize={16}
                                kind="stroke"
                                icon="st-search"
                                tw="text-icon-pale mr-2 flex-shrink-0"
                            />
                            <input
                                tw="text-text-base text-base h-6 min-width[30px] max-width[160px] w-full flex-shrink"
                                placeholder="Search..."
                                value={searchValue}
                                onChange={e => onSearchChange(e.target.value)}
                            />
                        </label>
                    )}
                    {!isEmptyOrUndefinedish(actionTitle) && (
                        <WireButton appearance={Appearance.Filled} onClick={onAction}>
                            {actionTitle}
                        </WireButton>
                    )}
                </div>
            </div>
            {children}
        </div>
    );
};
